import React from "react";

const ViewWorkflowGallery = () => {
  return <div>ViewWorkflowGallery</div>;
};

export default ViewWorkflowGallery;
